import React, { useState } from 'react'
import { Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosConfig';
import * as CustomToast from './CustomToastMessage';


function ChangePassword() {

    const navigate = useNavigate()
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isPasswordVisible, setIsPasswordVisible] = useState(false)
    const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false)

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const toggleNewPasswordVisibility = () => {
        setIsNewPasswordVisible(!isNewPasswordVisible);
    };

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/user/password/change`,
                { currentPassword, newPassword },
            )
            CustomToast.success(response.data.message);
            setNewPassword('');
            setCurrentPassword('');
            handleClose();
            localStorage.removeItem('token');
            navigate('/login')

        } catch (error) {
            CustomToast.error(error.response?.data?.message);
        }
        finally {
            setLoading(false);
        }
    }
    return (
        <>

            <Dropdown.Item onClick={handleShow}>
                <img src="/images/png/lock.png" width={24} alt="" />
                Change Password
            </Dropdown.Item>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Change Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-6">
                            <Form.Group className="mb-3 position-relative">
                                <Form.Label>Old Password</Form.Label>
                                <Form.Control
                                    type={isNewPasswordVisible ? "text" : "password"}
                                    placeholder="Enter Old Password"
                                    id="currentPassword"
                                    name="currentPassword"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                />
                                <span
                                    className="password-icon"
                                    onClick={toggleNewPasswordVisibility}
                                >
                                    <img src={`/images/png/${isNewPasswordVisible ? "eye-show.png" : "eye-hide.png"}`} alt="" />
                                </span>
                            </Form.Group>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Group className="mb-3 position-relative">
                                <Form.Label>New Password</Form.Label>
                                <Form.Control
                                    type={isPasswordVisible ? "text" : "password"}
                                    placeholder="Enter New Password"
                                    id="newPassword"
                                    name="newPassword"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <span
                                    className="password-icon"
                                    onClick={togglePasswordVisibility}
                                >
                                    <img src={`/images/png/${isPasswordVisible ? "eye-show.png" : "eye-hide.png"}`} alt="" />
                                </span>
                            </Form.Group>
                        </div>
                    </div>
                    <button
                        className='btn-primary px-5 d-flex justify-content-center m-auto'
                        disabled={loading} onClick={handleSubmit}
                    >
                        Save
                    </button>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ChangePassword